import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import newPurchase from '../../../redux-store/reducers/newPurchase';
import { Dialog, Button } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router';

export const NomineePopup = () => {
    const [open, setOpen] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const { noNomineeFolios }: { noNomineeFolios: string[] } = useSelector(
        ({ portfolio: { noNomineeFolios } }: RootStateType) => ({
            noNomineeFolios,
        }),
    );
    useEffect(() => {
        const isHomePath = location.pathname === '/portal/home';
        if (noNomineeFolios.length > 0 && isHomePath) {
            setOpen(true);
        }
    }, [noNomineeFolios.length]);
    return (
        <Dialog maxWidth={'sm'} open={open} aria-labelledby="note-modals">
            <div className="note-modals">
                <h3>Update Nominee</h3>
                <p>
                    Please update your Choice of Nomination (Updation of Nominee or Opting out of
                    Nomination), for your folios
                </p>
                <div className="note-modals-btns">
                    <Button
                        className="customBtn"
                        onClick={() => {
                            setOpen(false);
                            history.replace('/portal/nct/update-nominee');
                        }}
                    >
                        Update Nominee
                    </Button>
                    <Button
                        className="customBtn"
                        onClick={() => {
                            setOpen(false);
                        }}
                    >
                        Cancel
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};
